module.exports = __webpack_public_path__ + "img/logo_ahs_01@2x.256aca86.png";